<template>
  <div class="view-container">
    <BjDrawerForm
      ref="BjDrawerForm"
      :form="form"
      :rules="rules"
      :confirmDis="openType == 'view'"
      width="720px"
      label-width="120px"
      @handleConfirm="handleConfirm"
      @close="handleClose"
    >
      <BjDivider>{{ $t('CustomerFunction.company') }}</BjDivider>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.companyName')" prop="companyName">
            <BjInput :disabled="openType=='view'" v-model="form.companyName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('billingPage.companyName')" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('toolsProfit.industry')" prop="industry">
            <BjSelectLov :disabled="openType=='view'" v-model="form.industry" :placeholder="$t('toolsProfit.industry')" :option-list="USER_ONBOARDING_INDUSTRY_LIST" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item label="ABN" prop="abn">
            <BjInput :disabled="openType=='view'" v-model="form.abn" :maxlength="MAX_LENGTH.DEFAULT" placeholder="ABN" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.customerInfo.CustomerType')" prop="customerType">
            <BjSelectLov :disabled="openType=='view'" v-model="form.customerType" :placeholder="$t('AccountManagementAdd.customerInfo.CustomerType')" :option-list="USER_CUSTOMER_TYPE_LIST" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan*2">
          <el-form-item :label="$t('CustomerFunction.website')" prop="website">
            <BjInput :disabled="openType=='view'" v-model="form.website" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('CustomerFunction.website')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <BjDivider>{{ $t('CustomerFunction.contact') }}</BjDivider>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.person')" prop="primaryContactPerson">
            <BjInput :disabled="openType=='view'" v-model="form.primaryContactPerson" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('CustomerFunction.person')" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.phone')" prop="phone">
            <BjInputNumber :disabled="openType=='view'" v-model="form.phone" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('CustomerFunction.phone')" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.customerInfo.GeneralEmail')" prop="email">
            <BjInput :disabled="openType=='view'" v-model="form.email" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('AccountManagementAdd.customerInfo.GeneralEmail')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.customerInfo.BillEmail')" prop="billingAddressEmail">
            <BjInput :disabled="openType=='view'" v-model="form.billingAddressEmail" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('AccountManagementAdd.customerInfo.BillEmail')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan*2">
          <el-form-item :label="$t('CustomerFunction.address')" prop="businessAddress">
            <BjInput :disabled="openType=='view'" v-model="form.businessAddress" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('CustomerFunction.address')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <BjDivider>{{ $t('CustomerFunction.business') }}</BjDivider>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.customerInfo.ifLocal')" prop="ifLocal">
            <BjSelectLov :disabled="openType=='view'" v-model="form.ifLocal" :option-list="STATUS_YES_TRUE" :placeholder="$t('AccountManagementAdd.customerInfo.ifLocal')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.customerInfo.currencySymbol')" prop="currencySymbol">
            <BjSelectLov :disabled="openType=='view'" v-model="form.currencySymbol" lov-code="CHANNEL_CURRENCY" :placeholder="$t('AccountManagementAdd.customerInfo.currencySymbol')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.sku')" prop="skuVolume">
            <BjInputNumber :disabled="openType=='view'" v-model="form.skuVolume" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('CustomerFunction.sku')" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.model')" prop="businessModel">
            <BjSelectLov :disabled="openType=='view'" v-model="form.businessModel" :option-list="[{label:'B2B',value:'B2B'},{label:'B2C',value:'B2C'}]" multiple :collapseTags="false" :placeholder="$t('CustomerFunction.model')"/>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.customer')" prop="customerService">
            <BjSelectLov :disabled="openType=='view'" v-model="form.customerService" :option-list="customerNameList" :placeholder="$t('CustomerFunction.customer')" @change="sendID"/>
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.customerInfo.billingAddress')" prop="billingAddress1">
            <BjInput :disabled="openType=='view'" v-model="form.billingAddress1" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('AccountManagementAdd.customerInfo.billingAddress')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.start')" prop="expectedStartDate">
            <el-date-picker
            :disabled="openType=='view'"
            v-model="form.expectedStartDate"
            class="full-width"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :placeholder="$t('CustomerFunction.start')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.FreightMargin')" prop="freightMargin">
            <BjInputNumber :disabled="openType=='view'" v-model="form.freightMargin" :max="100" :min="0" :precision="0" :not-auto-zero="true" :placeholder="$t('CustomerFunction.FreightMargin')" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.payment')" prop="paymentMode">
            <BjSelectLov :disabled="openType=='view'" v-model="form.paymentMode" :option-list="paymentList" @change="clearForm" :placeholder="$t('CustomerFunction.payment')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="form.paymentMode != 1">
          <el-form-item :label="$t('CustomerFunction.PaymentTerm')" prop="paymentTerm">
            <BjInputNumber :disabled="openType=='view'" v-model="form.paymentTerm" :max="100" :min="0" :precision="0" :not-auto-zero="true" :placeholder="$t('CustomerFunction.PaymentTerm')" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="form.paymentMode == 2">
          <el-form-item :label="$t('CustomerFunction.CreditLimit')" prop="creditLimit">
            <BjInputNumber :disabled="openType=='view'" v-model="form.creditLimit" :max="10000000" :min="0" :precision="2" :not-auto-zero="true" :placeholder="$t('CustomerFunction.CreditLimit')" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="form.paymentMode == 3">
          <el-form-item :label="$t('CustomerFunction.BondLimit')" prop="bondLimit">
            <BjInputNumber :disabled="openType=='view'" v-model="form.bondLimit" :max="10000000" :min="0" :precision="2" :not-auto-zero="true" :placeholder="$t('CustomerFunction.BondLimit')" clearable/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan" v-if="form.paymentMode != 1">
          <el-form-item :label="$t('CustomerFunction.NETEOM')" prop="isMb">
            <BjSelectLov :disabled="openType=='view'" v-model="form.isMb" :option-list="isMbList" :placeholder="$t('CustomerFunction.NETEOM')"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.PalletText')" prop="estimationPalletQty">
            <BjInputNumber :disabled="openType=='view'" v-model="form.estimationPalletQty" :placeholder="$t('CustomerFunction.PalletText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.WeeklySalesText')" prop="estWeeklyRevenue">
            <BjInputMoney :disabled="openType=='view'" v-model="form.estWeeklyRevenue" :placeholder="$t('CustomerFunction.WeeklySalesText')" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <BjDivider>{{ $t('CustomerFunction.onboardingFiles') }}</BjDivider>
      <el-row>
        <el-col :span="colSpan">
          <el-button @click="openSelectFile">{{ $t('fileSearch.page.FileUpload') }}</el-button>
        </el-col>
      </el-row>
    </BjDrawerForm>
    <el-dialog
      :title="$t('fileSearch.page.FileUpload')"
      :visible.sync="dialogVisible"
      width="666px"
      :before-close="handleCancel"
    >
      <el-form ref="dialogForm" :model="dialogForm" label-width="170px" label-position="left" class="bj-query-form bj-query-form-for-cal-height">
        <el-row>
          <el-col v-for="(item,index) in fileTitleList" :key="index">
            <el-form-item :label="item +' : '" style="position: relative;">
              <UploadFile :ref="'UploadFileRef' + index" class="avatar-uploader" :limit-size="5 * 1024" show-file-list :disabled="openType=='view'"
                :accept="index == '3'?'image/png,image/jpeg,':index == '5'?'.eml,.pdf':'.pdf'" 
                auto-upload limit-hide @handleFileListChange="fileListChange($event,item)">
                <template slot="default">
                  <div class="flex-align">
                    <el-button :disabled="openType=='view'" size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                  </div>
                </template>
              </UploadFile>
              <el-button :disabled="disabledDown(item)" @click="downloadOnboardingFile(item)" style="position: absolute;top: 1px;left: 100px;" size="small" type="primary" plain>{{ $t('downloadText') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">{{ $t('cancelText') }}</el-button>
        <el-button :disabled="openType=='view'" type="primary" @click="handleSend">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { funConfigApi } from '@/api';
import { USER_ONBOARDING_INDUSTRY_LIST,USER_CUSTOMER_TYPE_LIST,STATUS_YES_TRUE } from '@/utils/constants';
import UploadFile from './UploadFile';
import { getLanguage } from '@/lang/index';
import { downloadImageUrl } from '@/utils';

const getDefaultForm = () => {
  return {
    companyName: null,
    industry: null,
    abn: null,
    customerType: null,
    website: null,
    primaryContactPerson: null,
    phone: null,
    email: null,
    billingAddressEmail: null,
    businessAddress: null,
    ifLocal: null,
    currencySymbol: null,
    skuVolume: null,
    businessModel: [],
    billingAddress1: null,
    // customerService: null,
    // customerServiceId: null,
    expectedStartDate: null,
    paymentMode: 1,
    paymentTerm: null,
    creditLimit: null,
    bondLimit: null,
    freightMargin: null,
    isMb: 0,
    estimationPalletQty: null,
    estWeeklyRevenue: null,
    allFileList:[],
  };
};

export default {
  components: {
    UploadFile
  },
  data() {
    return {
      // 表单参数
      language: getLanguage(),
      openType: null,
      colSpan:8,
      USER_ONBOARDING_INDUSTRY_LIST,
      USER_CUSTOMER_TYPE_LIST,
      STATUS_YES_TRUE,
      customerNameList:[],
      paymentList:[
        { label:this.$t('CustomerFunction.wallet'), value: 1 },
        { label:this.$t('CustomerFunction.credit'), value: 2 },
        { label:this.$t('CustomerFunction.bond'), value: 3 },
      ],
      isMbList:[
        { label:'NET', value: 0 },
        { label:'EOM', value: 1 },
      ],
      fileTitleList:[
        this.$t('CustomerFunction.FilesName1'),
        this.$t('CustomerFunction.FilesName2'),
        this.$t('CustomerFunction.FilesName3'),
        this.$t('CustomerFunction.FilesName4'),
        this.$t('CustomerFunction.FilesName5'),
        this.$t('CustomerFunction.FilesName6'),
      ],
      fileTitleKeyList:[
        'Signed Rate Card',
        'Terms And Condition',
        'Credit Application',
        'Customer Analysis',
        'Inbound Checklist',
        'Email Confirmation',
      ],
      form: getDefaultForm(),
      dialogVisible:false,
      dialogForm:{
        'Signed Rate Card':[],
        'Terms And Condition':[],
        'Credit Application':[],
        'Customer Analysis':[],
        'Inbound Checklist':[],
        'Email Confirmation':[],
      },
      canDownFile:true,
    };
  },
  computed: {
    // 表单校验
    rules() {
      const validateEmailAddress = (rule, value, callback) => {
        this.$nextTick(() => {
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!value) {
            callback(new Error(this.$t('emptyWarningText')));
          }
          if (!emailRegex.test(value)) {
            callback(new Error(this.$t('formatErrorText')));
          }
          callback();
        });
      };
      // const validateFreightMargin = (rule, value, callback) => {
      //   this.$nextTick(() => {
      //     if (!value && value !== 0) {
      //       callback(new Error(this.$t('emptyWarningText1')));
      //     } else if (!Number.isInteger(value) || value < 0 || value > 100) {
      //       callback(new Error('请输入0-100的正整数'));
      //     }
      //     callback();
      //   });
      // };
      return {
        companyName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        industry: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        customerType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        abn: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        primaryContactPerson: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        phone: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        email: [{ required: true, validator: validateEmailAddress, trigger: 'blur' }],
        billingAddressEmail: [{ required: true, validator: validateEmailAddress, trigger: 'blur' }],
        ifLocal: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        currencySymbol: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        skuVolume: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        businessModel: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        billingAddress1: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        // customerService: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        expectedStartDate: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        paymentMode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        paymentTerm: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        creditLimit: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        bondLimit: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        freightMargin: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        isMb: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        estimationPalletQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        estWeeklyRevenue: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      };
    },
  },
  methods: {
    clearForm(){
      const form = this.$refs.BjDrawerForm.$refs.form;
      if (form) form.clearValidate();
    },
    // 验证文件是否可以使用下载按钮
    resolveFileTitleKey(item){
      if(this.dialogForm[item]) return item;
      const index = this.fileTitleList.indexOf(item);
      return this.fileTitleKeyList[index] || item;
    },
    disabledDown(item){
      const fileKey = this.resolveFileTitleKey(item);
      return !(this.dialogForm[fileKey] && this.dialogForm[fileKey].length > 0);
    },
    // Download onboarding file
    downloadOnboardingFile(item) {
      const fileKey = this.resolveFileTitleKey(item);
      const file = this.dialogForm[fileKey] && this.dialogForm[fileKey][0];
      if (!file) return;
      downloadImageUrl(file.url, file.name);
    },
    // Open dialog
    openSelectFile(){
      if(this.openType == 'add'){
        this.dialogVisible = true
      }else{
        if(this.form.allFileList && this.form.allFileList.length>0){
          this.dialogForm = this.reverseTransformDialogForm(this.form.allFileList)
          setTimeout(() => {
            this.dialogVisible = true
          }, 300);
          setTimeout(() => {
            this.$refs['UploadFileRef0'][0].fileList = this.dialogForm['Signed Rate Card']
            this.$refs['UploadFileRef1'][0].fileList = this.dialogForm['Terms And Condition']
            this.$refs['UploadFileRef2'][0].fileList = this.dialogForm['Credit Application']
            this.$refs['UploadFileRef3'][0].fileList = this.dialogForm['Customer Analysis']
            this.$refs['UploadFileRef4'][0].fileList = this.dialogForm['Inbound Checklist']
            this.$refs['UploadFileRef5'][0].fileList = this.dialogForm['Email Confirmation']
          }, 500);
        }else{
          this.dialogForm={
            'Signed Rate Card':[],
            'Terms And Condition':[],
            'Credit Application':[],
            'Customer Analysis':[],
            'Inbound Checklist':[],
            'Email Confirmation':[],
          },
          setTimeout(() => {
            this.dialogVisible = true
          }, 300);
          setTimeout(() => {
            this.$refs['UploadFileRef0'][0].fileList = this.dialogForm['Signed Rate Card']
            this.$refs['UploadFileRef1'][0].fileList = this.dialogForm['Terms And Condition']
            this.$refs['UploadFileRef2'][0].fileList = this.dialogForm['Credit Application']
            this.$refs['UploadFileRef3'][0].fileList = this.dialogForm['Customer Analysis']
            this.$refs['UploadFileRef4'][0].fileList = this.dialogForm['Inbound Checklist']
            this.$refs['UploadFileRef5'][0].fileList = this.dialogForm['Email Confirmation']
          }, 500);
        }
      }
    },
    // 文件上传弹窗确认
    handleSend() {
      // 对象转数组 然后执行some操作
      if(Object.entries(this.dialogForm).some(item =>item[1].length == 0)){
        return this.$message.warning(this.$t('CustomerFunction.fileTips'));
      }else{
        // 赋值给allFileList用以传参
        this.form.allFileList = this.transformDialogForm(this.dialogForm)
        this.dialogVisible = false;
      }
    },
    // 数据转换==>>>后端传参
    transformDialogForm(original) {
      const result = [];
      for (const [fileType, files] of Object.entries(original)) {
        if (files.length > 0) {
          files.forEach(file => {
            result.push({
              name: file.name,
              url: file.url,
              type: fileType
            });
          });
        } else {
          result.push({
            name: null,
            url: null,
            type: fileType
          });
        }
      }
      return result;
    },
    // 数据转换==>>>页面回显
    reverseTransformDialogForm(transformedArray) {
      const result = {};
      // 遍历转换后的数组
      transformedArray.forEach(item => {
        const fileType = item.type;
        // 如果该文件类型在结果对象中还不存在，初始化一个空数组
        if (!result[fileType]) {
          result[fileType] = [];
        }
        // 只有当文件名和文件URL都不为空时，才添加到对应文件类型的数组中
        if (item.name !== null && item.url !== null) {
          result[fileType].push({
            name: item.name,
            url: item.url
          });
        }
      });
      return result;
    },
    // 关闭弹框
    handleCancel() {
      if(this.openType=='add'){
        this.clearFileCloseDialog()
      }else{
        // 清空数据 关闭文件弹窗
        if(this.form.allFileList && this.form.allFileList.length>0){
          this.dialogForm = this.reverseTransformDialogForm(this.form.allFileList)
          setTimeout(() => {
            this.$refs['UploadFileRef0'][0].fileList = this.dialogForm['Signed Rate Card']
            this.$refs['UploadFileRef1'][0].fileList = this.dialogForm['Terms And Condition']
            this.$refs['UploadFileRef2'][0].fileList = this.dialogForm['Credit Application']
            this.$refs['UploadFileRef3'][0].fileList = this.dialogForm['Customer Analysis']
            this.$refs['UploadFileRef4'][0].fileList = this.dialogForm['Inbound Checklist']
            this.$refs['UploadFileRef5'][0].fileList = this.dialogForm['Email Confirmation']
          }, 300);
          this.dialogVisible = false
        }else{
          this.dialogForm={
            'Signed Rate Card':[],
            'Terms And Condition':[],
            'Credit Application':[],
            'Customer Analysis':[],
            'Inbound Checklist':[],
            'Email Confirmation':[],
          },
          setTimeout(() => {
            this.$refs['UploadFileRef0'][0].fileList = this.dialogForm['Signed Rate Card']
            this.$refs['UploadFileRef1'][0].fileList = this.dialogForm['Terms And Condition']
            this.$refs['UploadFileRef2'][0].fileList = this.dialogForm['Credit Application']
            this.$refs['UploadFileRef3'][0].fileList = this.dialogForm['Customer Analysis']
            this.$refs['UploadFileRef4'][0].fileList = this.dialogForm['Inbound Checklist']
            this.$refs['UploadFileRef5'][0].fileList = this.dialogForm['Email Confirmation']
          }, 300);
          this.dialogVisible = false
        }
      }
    },
    handleClose(){
      this.clearFileCloseDialog()
    },
    // 清空数据 关闭文件弹窗
    clearFileCloseDialog(){
      // 清空页面值集
      if (this.$refs['UploadFileRef0'] && this.$refs['UploadFileRef0'][0]) {
        this.$refs['UploadFileRef0'][0].fileList = []
      }
      if (this.$refs['UploadFileRef1'] && this.$refs['UploadFileRef1'][0]) {
        this.$refs['UploadFileRef1'][0].fileList = []
      }
      if (this.$refs['UploadFileRef2'] && this.$refs['UploadFileRef2'][0]) {
        this.$refs['UploadFileRef2'][0].fileList = []
      }
      if (this.$refs['UploadFileRef3'] && this.$refs['UploadFileRef3'][0]) {
        this.$refs['UploadFileRef3'][0].fileList = []
      }
      if (this.$refs['UploadFileRef4'] && this.$refs['UploadFileRef4'][0]) {
        this.$refs['UploadFileRef4'][0].fileList = []
      }
      if (this.$refs['UploadFileRef5'] && this.$refs['UploadFileRef5'][0]) {
        this.$refs['UploadFileRef5'][0].fileList = []
      }
      // 清空字段值集
      this.dialogForm = {
        'Signed Rate Card':[],
        'Terms And Condition':[],
        'Credit Application':[],
        'Customer Analysis':[],
        'Inbound Checklist':[],
        'Email Confirmation':[],
      }
      this.dialogVisible = false
    },
    // 上传的文件列表
    fileListChange(file,name) {
      if(name == this.$t('CustomerFunction.FilesName1')){
        this.$refs['UploadFileRef0'].fileList = file&&file.map(item => { return {name: item.name,  url: item.url}});
        this.dialogForm['Signed Rate Card'] = this.$refs['UploadFileRef0'].fileList
      }
      if(name == this.$t('CustomerFunction.FilesName2')){
        this.$refs['UploadFileRef1'].fileList = file&&file.map(item => { return {name: item.name,  url: item.url}});
        this.dialogForm['Terms And Condition'] = this.$refs['UploadFileRef1'].fileList;
      }
      if(name == this.$t('CustomerFunction.FilesName3')){
        this.$refs['UploadFileRef2'].fileList = file&&file.map(item => { return {name: item.name,  url: item.url}});
        this.dialogForm['Credit Application'] = this.$refs['UploadFileRef2'].fileList;
      }
      if(name == this.$t('CustomerFunction.FilesName4')){
        this.$refs['UploadFileRef3'].fileList = file&&file.map(item => { return {name: item.name,  url: item.url}});
        this.dialogForm['Customer Analysis'] = this.$refs['UploadFileRef3'].fileList;
      }
      if(name == this.$t('CustomerFunction.FilesName5')){
        this.$refs['UploadFileRef4'].fileList = file&&file.map(item => { return {name: item.name,  url: item.url}});
        this.dialogForm['Inbound Checklist'] = this.$refs['UploadFileRef4'].fileList;
      }
      if(name == this.$t('CustomerFunction.FilesName6')){
        this.$refs['UploadFileRef5'].fileList = file&&file.map(item => { return {name: item.name,  url: item.url}});
        this.dialogForm['Email Confirmation'] = this.$refs['UploadFileRef5'].fileList;
      }
    },
    // 接收参数打开侧边栏
    show(row) {
      if(this.openType == 'add'){
        this.form = Object.assign(getDefaultForm());
      }else{
        funConfigApi.getOnboardingDetail({id:row.id}).then(res => {
          this.form = Object.assign(getDefaultForm(), res || {});
          if(this.openType == 'edit' && this.form.allFileList && this.form.allFileList.length>0){
            this.dialogForm = this.reverseTransformDialogForm(this.form.allFileList)
          }
        });
      }
      this.$refs.BjDrawerForm.setTitle(
        this.openType == 'edit' ? this.$t('editText') : this.openType == 'add' ? this.$t('addText') : this.$t('viewText'),
      );
      setTimeout(() => {
        this.$refs.BjDrawerForm.show();
      }, 500);
    },
    // sendID(n,m){
    //   this.form.customerServiceId = m.customerServiceId
    // },
    // 保存数据
    handleConfirm() {
      if(this.form.paymentMode == 1){
        this.form.creditLimit = null
        this.form.bondLimit = null
        this.form.paymentTerm = null
        this.form.isMb = 0
      }
      if(this.form.paymentMode == 2){
        this.form.bondLimit = null
      }
      if(this.form.paymentMode == 3){
        this.form.creditLimit = null
      }
      if(Object.entries(this.dialogForm).some(item =>item[1].length == 0)){
        return this.$message.warning(this.$t('CustomerFunction.fileTips'));
      }
      const POST_DATA = this.form
      if (this.openType == 'add') {
        this.addApi(POST_DATA);
      }
      if (this.openType == 'edit') {
        this.editApi(POST_DATA);
      }
    },
    // 编辑
    editApi(API_DATA) {
      funConfigApi.putOnboardingList(API_DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.clearFileCloseDialog()
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    // 新增
    addApi(API_DATA) {
      funConfigApi.addOnboardingList(API_DATA).then(res => {
        console.log(res,'res');
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.clearFileCloseDialog()
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    reFresh() {
      this.$emit('reFresh');
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
::v-deep .el-upload-list__item {
  transition: none !important;
}
</style>
